/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-12-05 12:01:58 
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-12-05 13:07:48
 */


import { Injectable } from "@angular/core";

import { ENV } from '../env/env';
import { HttpClient } from "@angular/common/http";
import { File } from '@ionic-native/file';
import { FileTransfer, FileTransferObject, FileUploadOptions } from '@ionic-native/file-transfer';

import { Platform } from "ionic-angular";
import { TransService } from "./trans.service";
import { PhotoLibrary } from "@ionic-native/photo-library";

@Injectable()
export class Video2Service {

  // private urlVimeo = 'https://api.vimeo.com/me/videos';

  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/videos`;
  private urlStorage = `${ENV.SERVER_URL}/${ENV.API_PATH}/storage`;
  constructor(
    private photoLibrary: PhotoLibrary,
    private transService: TransService,
    private http: HttpClient,
    private transfer: FileTransfer,
    private file: File,
    public platform: Platform,
  ) {
  }

  createVideo(uri) {
    return this.http.post(`${this.url}?lang=${this.transService.lang}`, {
      uri
    });
  }


  uploadVideoByUrl(type: string, id: string, fileUrl: any) {
    return this.http.get(`${this.urlStorage}/signed-video?fileType=${type}&id=${id}`)
      .switchMap(res => {
        // console.log('res', JSON.stringify(res));
        // this.loadingService.showLoading(false);
        const { url } = res['payload'];
        const fileTransfer: FileTransferObject = this.transfer.create();
        let options: FileUploadOptions = {
          httpMethod: 'PUT',
          chunkedMode: false,
          headers: {
            'Content-Type': `video/${type}`
          }
        };
        return fileTransfer.upload(fileUrl, url, options);
      });
  }


  downloadVideo(url: string): any {
    const filename = Date.now();
    const fileTransfer: FileTransferObject = this.transfer.create();

    if (this.platform.is('android')) {
      let path = this.file.externalRootDirectory + 'DCIM/K-Rush/' + filename + '.mp4';
      return fileTransfer.download(url, path);
    } else {
      let path = this.file.documentsDirectory + filename + '.mp4';
      return fileTransfer.download(url, path)
        .then(() => {
          return this.photoLibrary.saveVideo(path, 'K-RUSH');
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/video2.service.ts